<button [disabled]="loading || disabled" [type]="type" class="{{ classList }}" (click)="clickAction()">
	<div class="btn-spinner float-left" *ngIf="loading"></div>
	<span class="btn-label" *ngIf="!loading || !loadingText">
		<ng-content></ng-content>
	</span>
	<span class="btn-label" *ngIf="loading">{{ loadingText }}</span>
</button>
